import React, { useEffect, useMemo, useState } from 'react'
import CommonServiceInfoBar from '../CommonServiceInfoBar'
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { getData, getDataWithCache, postDataJSON } from '@services/CommonApiService';
import endpoints from '@config/endpoints';
import dayjs from 'dayjs';
import Button from '@components/common/Button';
import PlusSvgIcon from '../../../../assets/svg_main/plus.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { errorLogger } from '@utils/applicationLogUtils';
import PregnancyDetails from '../PregnancyTracking/PregnancyDetails';
import { updateAncService, updateChild } from '@store/actions/beneficiaryAction';
import { useDispatch } from 'react-redux';
import './index.css';
import { buttonNames, pregnancy_details_constant, serviceStatus } from '@constants/appConstants';
import ChildAddServicesModal from '../Child/ChildServices/ChildAddServicesModal';
import { ServiceListByChildBeneficiaryId } from './ChildTrackingServices';
import { areDatesSame, diffBetweenTwoDays, feildValidation } from '@utils/commonUtils';
import { getCompletedHbncServiceList, ServiceSubcategoryListByChildBeneficiaryHbncNo } from '../PNC/PNCServices';
import { getOngoingPNCDetails } from '../PNC/PNCConstants';
import HBYCServiceView from '../Child/HBYCServiceView';
import { getOngoingHBYCDetails } from '../Child/ChildtrackingConstant';
import { COMMON_CONSTANTS, dateFormate } from '@constants/index';
import { getServiceDetailsUnderCurrentDate } from '@services/ancApiServices';


const ChildServiceTracking = () => {

    const errorObj = {
        showError: false,
        errorMessage: '',
        errorField: '',
        isDisable: false
    }
    const navigate = useNavigate();
    const [serviceList, setServiceList] = useState<any>([]);
    const selectedChildServices = useSelector((state: RootState) => state?.beneficiary?.selectedChildServices);
    const selectedAncService = useSelector((state: RootState) => state?.beneficiary?.selectedAncService);
    const [serviceApiResponse, setServiceApiResponse] = useState<any>([]);
    const [isExpandAll, setIsExpandAll] = useState<boolean>(false);
    const [showAddServicesModal, setShowAddServicesModal] = useState<boolean>(false);
    const [modalContent, setModalContent] = useState<any>([]);
    const [childServicesData, setChildServicesData] = useState<any[]>([]);
    const [modalError, setModalError] = useState<any>([errorObj]);
    const [enableEditForNewBorn, setEnableEditForNewBorn] = useState<boolean>(false);
    const [enableSickChildCare, setEnableSickChildCare] = useState<boolean>(false);
    const isExpandable = ['pnc_child', 'hbyc'];
    const [dynamicModalContent, setDynamicModaContent] = useState<any>({
        title: 'Child Services',
        subTitle: 'Services',
    });
    const { id } = useParams();
    const dispatch = useDispatch();
    const childDetails = useSelector((state: RootState) => state.beneficiary.childDetails);
    const isHBNCSameDay = useSelector((state: RootState) => state.beneficiary.isHBNCSameDay);
    const isNewBornSameDay = useSelector((state: RootState) => state.beneficiary.isNewBornSameDay);
    const isHBYCSameDay = useSelector((state: RootState) => state.beneficiary.isHBYCSameDay);

    const latestServiceDate = useMemo(() => {
        const allDates = (serviceList || [])
            .map((s: any) => s.create_date)
            .filter(Boolean);

        if (!allDates.length) return null;
        return allDates.reduce((max: any, d: any) =>
            dayjs(d).isAfter(dayjs(max)) ? d : max
        );
    }, [serviceList]);
    const userRole =localStorage.getItem('userTypeName');
    const [childHBYCServiceDetails, setChildHBYCServiceDetails] = useState<any>({});
    useEffect(() => {
        intialFetch();
        return () => {
            dispatch(updateAncService('selectedAncService', []))
            dispatch(updateAncService('currentFacilityDetails', {}))
        };
    }, []);

    const pncDisableCondition=(days:any,updatedIsDisable:any)=>{
        if(days>45 ||updatedIsDisable?.disableChilServices ||(days < 2 && (childDetails?.place_of_delivery_name === 'Institutional' || childDetails?.place_of_delivery_name === 'Transit')) ){
            return true
        }
        else{
            return false;
        }
    }

    const handleModalError = (updatedIsDisable: any) => {
        const dateOfBirth = childDetails?.dob;
        const days = diffBetweenTwoDays(dateOfBirth, dayjs(), 'days');
        const ongoingHBYCDetails = getOngoingHBYCDetails(childDetails?.dob, dayjs());
        const currentDate = dayjs();
        
        const hbncLastPeriodEnd = 44;
        const hbncEndWithCoolingPeriod = hbncLastPeriodEnd + 90;
        const isHBNCDisabled = days > hbncEndWithCoolingPeriod || updatedIsDisable?.disableChilServices || 
            (days < 2 && (childDetails?.place_of_delivery_name === 'Institutional' || childDetails?.place_of_delivery_name === 'Transit'));
        
        const newBornEndDate = 45;
        const newBornEndWithCoolingPeriod = newBornEndDate + 90;
        const isNewBornDisabled = days > newBornEndWithCoolingPeriod || updatedIsDisable?.disableNewBorn;
        
        const hbycLastPeriodEnd = 463;
        const hbycEndWithCoolingPeriod = hbycLastPeriodEnd + 90;
        const hasOngoingHBYC = !!ongoingHBYCDetails?.[0]?.hbyc;
        const isHBYCDisabled = (!hasOngoingHBYC && days > hbycEndWithCoolingPeriod) || days < 90;
        
        const sickChildCareEndDate = dayjs(dateOfBirth).add(2, 'year');
        const sickChildCareEndWithCoolingPeriod = sickChildCareEndDate.add(90, 'day');
        const isSickChildCareDisabled = childDetails?.is_dead || currentDate.isAfter(sickChildCareEndWithCoolingPeriod);
        
        setEnableSickChildCare(!isSickChildCareDisabled);
        
        setModalError((prevState: any) => [
            ...prevState,
            {
              showError: false,
              errorMessage: '',
              errorField: 'HBNC',
              isDisable: isHBNCDisabled
            },
            {
                showError: false,
                errorMessage: '',
                errorField: 'HBYC',
                isDisable: isHBYCDisabled
            },
            {
                showError: false,
                errorMessage: '',
                errorField: 'New Born Care',
                isDisable: isNewBornDisabled
            }, 
            {
                showError: false,
                errorMessage: '',
                errorField: 'Sick Child Care',
                isDisable: isSickChildCareDisabled
            }, 
          ]);
    }

    const intialFetch = async () => {
        try {
            const childServiceList = await ServiceListByChildBeneficiaryId(id)
            const hasNewBorn = childServiceList?.data.filter((service: any) => service.service_category_code == pregnancy_details_constant.newBorn).length === 1;
            const newBornService = childServiceList?.data.find(
                (service: any) => service.service_category_code === pregnancy_details_constant.newBorn);
                const isNewBornPresent = !!newBornService;
                const isNewBornCreatedToday = isNewBornPresent && areDatesSame(newBornService?.create_date, dayjs(), 'days');
                if (isNewBornPresent && isNewBornCreatedToday && !childDetails?.is_dead) {
                    setEnableEditForNewBorn(true);
                    dispatch(updateChild('isNewBornSameDay', true));
                    const updatedIsDisable = {
                    disableNewBorn: false,
                    disableChilServices: false
                    }
                    handleModalError(updatedIsDisable);
                } else {
                    const updatedIsDisable = {
                    disableNewBorn: hasNewBorn,
                    disableChilServices: !hasNewBorn
                }
                dispatch(updateChild('isNewBornSameDay', false));
                handleModalError(updatedIsDisable);       
                }
            setServiceList(childServiceList?.data);
            handleServiceOnSameDay(childServiceList?.data || []);
            hbycOnSameDayCheck(childServiceList?.data || []);
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error)
        }
    }
    const getStatus = (item: any) => {
        switch (item?.service_category_code) {
            case pregnancy_details_constant.newBorn:
                return serviceStatus.completed;
            default: {
                const currentDate = dayjs().startOf('day');
                const serviceEndDate = dayjs(item?.service_end_dt).startOf('day');
                return currentDate.isBefore(serviceEndDate) || currentDate.isSame(serviceEndDate) 
                    ? serviceStatus.ongoing 
                    : serviceStatus.completed; 
            }
        }        
    };

    const isEndDateNeeded = (item: any) => {
        switch (item?.service_category_code) {
            case pregnancy_details_constant.pncChild:
                return true;
            case pregnancy_details_constant.hbyc:
                return true;
            default:
                return false;
        }
    }

    const validateDate = (date: any) => {
        return date ? dayjs(date) : '';
    }

    const getServiceDate = (item: any, option: string) => {
        if (option === 'start') {
            return validateDate(item?.service_start_dt);
        } else if (option === 'end') {
            return validateDate(item?.service_end_dt);
        } else {
            return validateDate(item?.service_start_dt);
        }
    };

    const handleExpandAll = (isChecked: any, serviceList: any, id: any) => {
        setIsExpandAll(isChecked);
        const expandableServices = serviceList.filter((item: any) => isExpandable.includes(item.service_category_code));
        const serviceNames = setAllServicesName(isChecked ? expandableServices : []);
        const ancMap = serviceNames.map((item: any) => item.match(/\d+/) ? item.match(/\d+/)[0] : 0);
        setServiceApiResponse([]);
        if (!isChecked) return;

        expandableServices?.forEach((service: any, index: number) => {
            const visitNo = ancMap[index];
            getServiceList(index, visitNo, service.service_period_name, service.service_category_code, id);
        });
    }

    const setAllServicesName = (data: any) => {
        const servicesName = data?.map((item: any) => item.service_period_name);
        dispatch(updateAncService('selectedAncService', servicesName));
        return servicesName;
    }

    const handleToggleChanges = (index: number, serviceList: any, serviceName: any, id: any) => { //child_id
        let visitNo;
        if (Number(serviceName)) {
            visitNo = serviceName;
        } else {
            visitNo = serviceName.match(/\d+/) ? serviceName.match(/\d+/)[0] : 0;
        }
        const periodName = serviceList[index]?.service_period_name;
        const serviceCode = serviceList[index]?.service_category_code;
        getServiceList(index, visitNo, periodName, serviceCode, id);
        const expandedService = selectedAncService?.includes(
            periodName,
        )
            ? selectedAncService?.filter(
                (item: any) => item != periodName,
            )
            : [...selectedAncService, periodName];

        if (expandedService?.length !== serviceList?.length) {
            setIsExpandAll(false);
        } else if (expandedService?.length === serviceList?.length) {
            setIsExpandAll(true);
        }
        dispatch(updateAncService('selectedAncService', expandedService));
    }

    const getServiceList = async (index: number, visitNo: number, periodName: string, serviceCode: any, id: any) => {
        try {
            let serviceList: any;
            switch (serviceCode) {
                case pregnancy_details_constant.pncChild:
                    {
                        serviceList = await ServiceSubcategoryListByChildBeneficiaryHbncNo(id, visitNo);
                        break;
                    }
                case pregnancy_details_constant.hbyc:
                    {
                        const payload = {
                            childBenefId: id,
                            hbycNo: visitNo
                        }
                        serviceList = await getData<any>(`${endpoints.getServiceSubCategoryListByChildBenefHbycNo}/${id}/${visitNo}`);
                        break;
                    }
            }

            setServiceApiResponse((prevState: any) => ({
                ...prevState,
                [periodName]: isEmptyObject(serviceList?.data) ? [] : serviceList?.data,
            }));
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error)
        }
    };

    const hbycOnSameDayCheck = async (childServiceListData: any[]) => {
        try {
            const ongoingHBYCDetails = getOngoingHBYCDetails(childDetails?.dob, dayjs());
            if(ongoingHBYCDetails?.[0]?.hbyc) {
                const hbycResponse = await getServiceDetailsUnderCurrentDate('hbyc', id || '', '', ongoingHBYCDetails?.[0]?.hbyc || 0, '');
                if(hbycResponse?.data?.length) {
                    const recentVisitData = hbycResponse.data.reduce((latest: any, current: any) => {
                        if (!latest) return current;
                        return dayjs(current.partition_key_trxn_date).isAfter(dayjs(latest.partition_key_trxn_date))
                            ? current : latest;
                    }, null);
                    const hbycItems = childServiceListData?.filter((svc: any) => svc.service_category_code === pregnancy_details_constant.hbyc) ?? [];
                    const hasCreateDateToday = hbycItems.some((svc: any) =>
                        svc.create_date && areDatesSame(svc.create_date, dayjs(), 'days')
                    );
                    if(hasCreateDateToday) {
                        const detailsToSet = {
                            ...recentVisitData,
                            visit_date: recentVisitData?.partition_key_trxn_date
                        };
                        dispatch(updateChild('isHBYCSameDay', true));
                        setChildHBYCServiceDetails(detailsToSet);
                    } else {
                        dispatch(updateChild('isHBYCSameDay', false));
                    }
                } else {
                    dispatch(updateChild('isHBYCSameDay', false));
                }
            } else {
                dispatch(updateChild('isHBYCSameDay', false));
            }
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error)
        }
    }

      const handleServiceOnSameDay = async (childServiceListData: any[]) => {
        try {
            const hbncItems = childServiceListData?.filter((svc: any) => svc.service_category_code === pregnancy_details_constant.pncChild) ?? [];
            if(!hbncItems.length) {
                dispatch(updateChild('isHBNCSameDay', false));
                return;
            }

            const latestHbnc = hbncItems[hbncItems.length - 1];
            const visitNo = latestHbnc?.service_period_name?.match(/\d+/)?.[0] || '';
            if(!visitNo) {
                dispatch(updateChild('isHBNCSameDay', false));
                return;
            }

            const hbncRes = await ServiceSubcategoryListByChildBeneficiaryHbncNo(childDetails?.benef_id || id, visitNo);
            if(hbncRes?.data?.length) {
                const recentVisitData = hbncRes.data[hbncRes.data.length - 1];
                const dateToCheck = recentVisitData?.updated_date || recentVisitData?.create_date;
                if(dateToCheck && areDatesSame(dateToCheck, dayjs(), 'days')) {
                    const editObj: any = {
                        ancVisitDate: dayjs(recentVisitData?.hbnc_visit_date).format(dateFormate.yyyy_mm_dd),
                        ancNo: 0,
                        serviceSubCategoryId: '',
                        serviceVisitId: '',
                        isServiceTakenOutside: '',
                    }
                    dispatch(updateAncService('viewEditMetaData', editObj));
                    dispatch(updateChild('isHBNCSameDay', true));
                } else {
                    dispatch(updateChild('isHBNCSameDay', false));
                }
            } else {
                dispatch(updateChild('isHBNCSameDay', false));
            }
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error);
            dispatch(updateChild('isHBNCSameDay', false));
        }
    }
    const isEmptyObject = (obj: any) => {
        return obj ? Object.keys(obj).length === 0 : true;
    };

    const handleButtonClick = async () => {
        const childServiceCategoryResponse = await getData<any>(`${endpoints.getChildServiceCategory}`);
        setChildServicesData(childServiceCategoryResponse.data);
        const modalItem = childServiceCategoryResponse.data?.map((item: any) => {
            return item.child_service_category_name
        })
        setModalContent(modalItem);
        setShowAddServicesModal(true);
    }

    const handleAddServiceModalClose = () => {
        setShowAddServicesModal(false);
      }
      const navigationMap: { [key: string]: { route: string; action: () => void } } = {
        'hbyc':{
            route: '/beneficiaries/hbyc/service', 
            action: () => navigate('/beneficiaries/hbyc/service', { state: { serviceDetails: childHBYCServiceDetails } })
        },
        'pnc_child':{
            route: '/beneficiaries/child/pnc-child', 
            action: () => navigate('/beneficiaries/child/pnc-child')
        },
        'new_born':{
            route: '/beneficiaries/service/new-born', 
            action: () => navigate('/beneficiaries/service/new-born')
        },
        'sick_child_care':{
            route: '/beneficiaries/sick-child-care', 
            action: () => navigate('/beneficiaries/sick-child-care')
        },
    };

   const handleServiceItemClick = async (item: string) => {
        const currentServiceData = childServicesData.find((ele: any) => ele.child_service_category_name === item);
        const isSickChildCareTaken = serviceList?.some((service: any) =>
            service.service_category_code === 'sick_child_care' &&
            service.create_date &&
            areDatesSame(service.create_date, dayjs(), 'days')
        );
        const currentServiceCode = currentServiceData?.child_service_category_code;
        dispatch(updateChild('currentChildServiceId', currentServiceData?.child_service_category_id));
        if (navigationMap[currentServiceCode]) {
            const { route, action } = navigationMap[currentServiceCode];
            const serviceDetails = {
                currRoute: route,
            }
            if(currentServiceCode === 'pnc_child') {                
                    dispatch(updateChild('isEditButtonClicked', false));
                    navigate('/beneficiaries/child/service-facility-details', { state: serviceDetails });
            } 
            else if(currentServiceCode === 'hbyc' ) { 
                    dispatch(updateChild('isEditButtonClicked', false));
                    navigate('/beneficiaries/child/service-facility-details', { state: serviceDetails });
            } 
            else if( currentServiceCode === 'sick_child_care') {
                    dispatch(updateChild('isEditButtonClicked', false));
                    navigate('/beneficiaries/child/service-facility-details', { state: serviceDetails });
            } 
            else if(currentServiceCode === 'new_born') {
                const isNewBornRegistered = serviceList?.some((service: any) =>
                    service.service_category_code === 'new_born'
                );

                if (isNewBornRegistered) {
                    dispatch(updateChild('isEditButtonClicked', true));
                    action(); 
                } else {
                    dispatch(updateChild('isEditButtonClicked', false));
                    navigate('/beneficiaries/child/service-facility-details', { state: serviceDetails });
                }
            }
        }
    }

    const handleViewClick = (item:any) => {
        if(item.service_category_code === pregnancy_details_constant.newBorn) {
            navigate('/beneficiaries/child/view/new-born')
        }
        else if(item.service_category_code === pregnancy_details_constant.sickChildCare) {
            dispatch(updateChild('sickChildCareVisitDate', item?.service_start_dt || null));
            navigate('/beneficiaries/child/view/sick-child-care')
        }
    }

    const handleEditClick = (item: any) => {
        if(item.service_category_code === pregnancy_details_constant.newBorn) {
            dispatch(updateChild('isEditButtonClicked', true));
            navigate('/beneficiaries/service/new-born');
        } else if(item.service_category_code === pregnancy_details_constant.sickChildCare) {
            dispatch(updateChild('isEditButtonClicked', true));
            dispatch(updateChild('sickChildCareVisitDate', item?.service_start_dt || null));
            navigate('/beneficiaries/sick-child-care');
        }
    }

    const enableEditButton = (item: any) => {
        if (!item) return false;
        const isOnLatestDate = latestServiceDate
            ? areDatesSame(item.create_date, dayjs(latestServiceDate), 'days')
            : false;
        switch (item?.service_category_code) {
            case pregnancy_details_constant.newBorn:
                return !childDetails?.is_dead && isOnLatestDate && dayjs().diff(dayjs(item.create_date), 'day') <= 90;
            case pregnancy_details_constant.sickChildCare:
                return (childDetails?.is_dead ? false : enableSickChildCare) && isOnLatestDate && dayjs().diff(dayjs(item.create_date), 'day') <= 90;
            default:
                return false;
        }
    }

    return (
        <div className='parent-child'>
            <div className='child-tracking'>
                {serviceList?.length > 0 && <div>
                    <label>{isExpandAll ? 'Close All' : 'Expand All'} &nbsp;
                        <input
                            type='checkbox'
                            onChange={(e) => handleExpandAll(e.target.checked, serviceList, id)}
                            checked={isExpandAll} />
                    </label>
                </div>}
                {userRole !== COMMON_CONSTANTS.FIELD_LEVEL_USER && (
                <Button
                    onClick={handleButtonClick}
                    buttonName={buttonNames.addServicesButton}
                    colorType={'primary'}
                    disabled={childDetails?.is_dead}
                    id={''}
                    icon={<PlusSvgIcon />}
                    iconPosition="left"
                />
            )}
            </div>
            <div style={{ backgroundColor: "#EAEAEA", padding:"4px 8px"}}>
                Child Services
            </div>

            {serviceList?.map((item: any, index: any) => (
                <div className="child-registration-modal" key={item?.service_period_name} >
                    <CommonServiceInfoBar
                        key={index}
                        isViewIcon={true}
                        isEditIcon={enableEditButton(item)}
                        isExpand={isExpandable.includes(item?.service_category_code)}
                        status={getStatus(item)}
                        isEndDateRequired={isEndDateNeeded(item)}
                        startDate={getServiceDate(item, 'start')}
                        type={'newBorn'}
                        endDate={getServiceDate(item, 'end')}
                        serviceName={item?.service_period_name}
                        onExpand={(data) => handleToggleChanges(index, serviceList, item?.service_period_name, id)}
                        isExpanded={selectedAncService?.includes(item?.service_period_name) ? true : false}
                        item={item}
                        isChildService={true}
                        onViewClick={() => 

                            handleViewClick(item)}
                        onEditClick={() => handleEditClick(item)}
                        isInfoRequired={!isExpandable.includes(item?.service_category_code)}
                    />
                    {selectedAncService?.includes(item?.service_period_name) && (
                        <>
                            <PregnancyDetails data={serviceApiResponse} periodName={item?.service_period_name} idx={index} isExpandAll={true} isChild={true} latestServiceDate={latestServiceDate} />
                        </>
                    )}
                </div>
            ))}
            <ChildAddServicesModal
                showModal={showAddServicesModal}
                onClose={handleAddServiceModalClose}
                content={modalContent}
                modalTitle={dynamicModalContent.title}
                modalSubTitle={dynamicModalContent.subTitle}
                handleItemClick={handleServiceItemClick}
                handleBack={handleAddServiceModalClose}
                errors={modalError}
            />
        </div>
    )
}

export default ChildServiceTracking